module.exports = "https://portperrypedals.ca/_res/img/napa.ba261be.png";